export default __webpack_public_path__ + "static/media/icon_transaction_dashboard.28471192.svg";